export const APIBASE = 'https://api.setcorp.com.br';
//export const APIBASE = 'http://localhost:54608';
export const AUTH_KEY = 'AUTH_KEY';

export const TIPOS_CHAVE = {
  Despesa: 1,
  Projeto: 2,
};

export const TIPOS_SOLICITACAO = {
  Despesa: 1,
  Projeto: 2,
  Comissao: 3,
};

export const TIPOS_CONTA = {
  ClienteFactoring: 1,
  ClienteComercio: 2,
  Despesa: 3,
  Fornecedor: 4,
  Banco: 5,
  Interna: 6,
  Receita: 7,
  FuncionarioOuPrestServico: 8,
};

export const diasDaSemana = {
  Domingo: 1,
  Segunda: 2,
  Terca: 4,
  Quarta: 8,
  Quinta: 16,
  Sexta: 32,
  Sabado: 64,
};

export const diasDaSemanaById = {
  [diasDaSemana.Domingo]: 'Dom',
  [diasDaSemana.Segunda]: 'Seg',
  [diasDaSemana.Terca]: 'Ter',
  [diasDaSemana.Quarta]: 'Qua',
  [diasDaSemana.Quinta]: 'Qui',
  [diasDaSemana.Sexta]: 'Sex',
  [diasDaSemana.Sabado]: 'Sab',
};

export const optionsFromKeyValue = (obj, isKeyNumber) =>
  Object.keys(obj).map(key => ({
    value: isKeyNumber ? Number(key) : key,
    label: obj[key],
  }));

export const diasDaSemanaOptions = optionsFromKeyValue(diasDaSemanaById, true);

export const semanaDeTrabalhoOptions = diasDaSemanaOptions.slice(1, 6);

export const caracteristicas = {
  ConfiguraAtendimento: 498,
  RealizaAgendamento: 499,
  ConverterFolhaSienge: 554,
  GerenciaSolicitacao: 559,
  PodeSolicitarDespesaProjeto: 560,
  VisualizaSolicitacaoLanc: 579,
  VisualizaRelatorioChaves: 589,
  VisualizaRelatorioSolicitacoes: 590,
};

export const tipoBooleano = {
  Sim: 1,
  Nao: 0,
};

export const statusSolicitacao = {
  Solicitada: 1,
  Aprovada: 2,
  Recusada: 3,
};

export const DATE_DEFAULT_FORMAT = 'DD/MM/YYYY';
export const DATETIME_DEFAULT_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const DATETIME_DEFAULT_SHORT_FORMAT = 'DD/MM/YYYY HH:mm';
export const DATETIME_DEFAULT_SUPER_SHORT_FORMAT = 'DD/MM HH:mm';
export const DATE_FORMAT_SERVER = 'YYYY-MM-DDTHH:mm:ss';

export const MASK_DATE = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const MASK_CPF = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];
export const MASK_CNPJ = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];
export const MASK_CEP = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
export const MASK_CEL = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const MASK_CEL_9 = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const TipoStatusSolicitacao = {
  Solicitado: 1,
  Processado: 2,
  Reprovado: 3,
  EmAnalise: 4,
  Ajustado: 5,
};
